import React from 'react';

import { VpHookFormInput } from '../../inputs';

export const ZipCodeInput = () => {
  const rules = {
    minLength: {
      value: 4,
      message: 'Zip code must be at least 4 characters long'
    }
  };
  return (
    <VpHookFormInput maxLength={20} rules={rules} required name="zipCode" placeholder="Zip Code" />
  );
};

export default ZipCodeInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/sign-up/ZipCodeInput.jsx